import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// import { withTranslation } from 'react-i18next';
import i18n from 'i18next';
import './barCharts.css';
import qs from 'query-string';
import { apis } from '../../api/index.js';
import { Form, Collapse, Table, message, Button } from 'antd';
import { Icon, Tabs, Cascader, Input } from 'antd';
import { ArrowRightIcon, shalouIcon } from '../../utils';
import classNames from 'classnames';

const { Panel } = Collapse;
const { TabPane } = Tabs;
const { TextArea } = Input;

class AiReport extends Component {
  static propTypes = {
    thumbIndex: PropTypes.string,
    aiReportChanged: PropTypes.func,
    dicomIds: PropTypes.array,
    selectedData: PropTypes.array,
    doctorConfigs: PropTypes.array,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const search = qs.parse(window.location.search);
    this.state = {
      reportList: [],
      dicomIds: this.props.dicomIds || [],
      defaultActiveKey: [0],
      totalLen: 0,
      selectedData: this.props.selectedData || [],
      dicomDrId: '',
      from: search.from,
      dicomId: search.dicomId,
      selectedDataArray: {
        diagIds: [],
      },
      doctorReviewList: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { thumbIndex, dicomIds, selectedData } = this.props;
    const pDicomIds = prevProps.dicomIds;
    const pThumbIndex = prevProps.thumbIndex;
    if (pDicomIds !== dicomIds || pThumbIndex !== thumbIndex) {
      this.setState({
        dicomIds,
        selectedData,
        selectedDataArray: {
          diagIds: [],
        },
      });
      window.localStorage.setItem('aiReport', '');

      if (dicomIds.length > 0) this.selectAiReport(thumbIndex, dicomIds);

      const { dicomId, from } = this.state;
      if (from === 'report' && dicomId) this.getDoctorReview(dicomId);
    }
    if (prevProps.selectedData !== selectedData) {
      this.setState({
        selectedData,
      });
    }
  }

  selectAiReport = (thumbIndex, dicomIds) => {
    const dicomDrId = dicomIds[parseInt(thumbIndex)];
    this.setState({
      dicomDrId,
    });
    apis.selectAiReport(dicomDrId).then(res => {
      if (res.code === '0') {
        const reportList = res.data;
        const defaultActiveKey = [];
        for (let i = 0; i < reportList.length; i++) {
          defaultActiveKey.push(reportList[i].id);
        }
        this.setState({
          reportList,
          totalLen: reportList.length,
          defaultActiveKey,
        });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  getDoctorReview = dicomId => {
    const post = {
      dicomDrId: dicomId,
      aiProductType: 6,
    };
    apis.doctorReviewRecord(post).then(res => {
      if (res.code === '0') {
        let result = res.data;
        result.forEach(item => {
          const parentCode = parseInt(item.parentResultCode);
          const code = parseInt(item.resultCode);
          item.value = [parentCode, code];
        });
        this.setState({
          doctorReviewList: result,
        });
      }
    });
  };

  getColumns = index => {
    const columns = [
      {
        title: '诊断建议',
        key: 'description' + index,
        dataIndex: 'description',
        width: '80%',
      },
      {
        title: '置信度',
        key: 'score' + index,
        dataIndex: 'score',
        render: value => <span>{parseInt(value * 100)} %</span>,
        width: '20%',
      },
    ];
    return columns;
  };

  getColumnsImgView = index => {
    const columns = [
      {
        title: '编号',
        key: 'id' + index,
        dataIndex: 'id',
        width: '20%',
        className: 'border-right',
        render: (value, record, i) => <span>{index + 1 + '-' + (i + 1)}</span>,
      },
      {
        title: '位置',
        key: 'position' + index,
        dataIndex: 'position',
        width: '40%',
      },
      {
        title: '影像所见',
        key: 'texture' + index,
        dataIndex: 'texture',
        width: '40%',
      },
    ];
    return columns;
  };

  handleChangeSelection = (record, selected, selectedRows) => {
    const { selectedData, dicomDrId } = this.state;
    if (selectedRows.length > 0) {
      let flag = true;
      selectedData.forEach(item => {
        if (item.dicomId === dicomDrId) {
          item.adoptVO.forEach(data => {
            if (data.diagId === selectedRows[0].aiReportDiagId) {
              flag = false;
              const ids = [];
              selectedRows.forEach(row => {
                ids.push(row.id);
              });
              data.findingIds = ids;
            }
          });
        }
      });
      if (flag) {
        const ids = [];
        selectedRows.forEach(row => {
          ids.push(row.id);
        });
        selectedData.forEach(item => {
          if (dicomDrId === item.dicomId) {
            item.adoptVO.push({
              diagId: selectedRows[0].aiReportDiagId,
              findingIds: ids,
            });
          }
        });
      }
    } else {
      selectedData.forEach((item, index) => {
        if (item.dicomId === dicomDrId) {
          item.adoptVO.forEach((data, i) => {
            if (data.diagId === record.aiReportDiagId)
              item.adoptVO.splice(i, 1);
          });
        }
      });
    }

    //提取选中的ids
    const diagIds = [];
    let findingIds = [];
    selectedData.forEach(r => {
      r.adoptVO.forEach(a => {
        diagIds.push(a.diagId);
        findingIds = findingIds.concat(a.findingIds);
      });
    });
    const selectedDataArray = {
      diagIds,
      findingIds,
    };
    window.localStorage.setItem('aiReport', JSON.stringify(selectedDataArray));
    this.props.aiReportChanged();
    this.getAIReportContent(selectedDataArray);
    this.setState({
      selectedData,
      selectedDataArray,
    });
  };

  getAIReportContent = report => {
    const { reportList } = this.state;
    const diagIds = report.diagIds;
    const findingIds = report.findingIds;
    let diagContent = [],
      findingContent = [];
    reportList.forEach(r => {
      if (diagIds.indexOf(r.id) >= 0) diagContent.push(r.description);
      const findings = r.findings || [];
      findings.forEach(f => {
        if (findingIds.indexOf(f.id) >= 0)
          findingContent.push(f.position + '，' + f.texture);
      });
    });
    diagContent = diagContent.join(`\n`);
    findingContent = findingContent.join(`\n`);
    this.setState({
      findingContent,
      diagContent,
    });
  };

  getReportContent = () => {
    const { reportList } = this.state;

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      },
      onSelect: (record, selected, selectedRows) => {
        // console.log(record, selected, selectedRows);
        this.handleChangeSelection(record, selected, selectedRows);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
        this.handleChangeSelection(changeRows[0], selected, selectedRows);
        // console.log(selected, selectedRows, changeRows);
      },
    };
    return reportList.map((item, index) => {
      const columns = this.getColumns(index);
      const columns1 = this.getColumnsImgView(index);
      if (!item.findings || item.findings.length === 0) {
        item.findings = [];
        item.findings.push({
          id: 0,
          position: '无',
          texture: '无',
        });
      }
      return (
        <Panel header={this.getTitle(index)} key={item.id}>
          <div className="ai-report-content">
            <Table
              columns={columns}
              dataSource={[item]}
              pagination={false}
              rowKey={record => record.id + '' + index + 'view'}
              key={record => record.id + '' + index + 'view'}
            />
            <div className="title">影像所见</div>
            <Table
              columns={columns1}
              dataSource={item.findings}
              rowKey={record => record.id + '' + index + 'sug'}
              key={record => record.id + '' + index + 'sug'}
              rowSelection={rowSelection}
              pagination={false}
              locale={{ emptyText: '无数据' }}
            />
          </div>
        </Panel>
      );
    });
  };

  getTitle = index => {
    return <div className="title">诊断 {index + 1}</div>;
  };

  updateAdopted = () => {
    const { selectedData } = this.state;
    let flag = false;
    selectedData.forEach(item => {
      if (item.adoptVO[0] && item.adoptVO[0].diagId) flag = true;
    });
    if (flag) {
      apis.updateAdopted(selectedData).then(res => {
        if (res.code === '0') {
          message.success('报告内容已生成，请在填写报告页面查看');
          window.localStorage.setItem('updatedAiReport', new Date().getTime());
        } else {
          message.error(res.message);
        }
      });
    } else {
      message.success('报告内容已生成，请在填写报告页面查看');
      window.localStorage.setItem('updatedAiReport', new Date().getTime());
    }
  };

  collapseCallback = key => {
    this.setState({
      defaultActiveKey: key,
    });
  };

  render() {
    let {
      from,
      dicomId,
      findingContent,
      diagContent,
      doctorReviewList,
    } = this.state;
    const reviewDoctorName = (doctorReviewList[0] || {}).boxUserName;
    const reviewStatus = (doctorReviewList[0] || {}).status;
    const textAreaValue = (doctorReviewList[0] || {}).textAreaValue;
    const { doctorConfigs } = this.props;
    findingContent = findingContent || '';
    findingContent = findingContent.replace(/\r\n/g, '<br />');
    findingContent = findingContent.replace(/\n/g, '<br />');

    diagContent = diagContent || '';
    diagContent = diagContent.replace(/\r\n/g, '<br />');
    diagContent = diagContent.replace(/\r\n/g, '<br />');

    const aiReport = classNames({
      'ai-report-div': true,
      'padding-bottom': from === 'report' && dicomId,
    });
    const aiRight = classNames({
      right: true,
      'ai-right': !(from === 'report' && dicomId),
    });
    return (
      <div className={aiReport}>
        <Tabs defaultActiveKey="1">
          <TabPane tab="AI 智能诊断" key="1">
            <div className="ai-report">
              <div className="list-title">
                <span className={aiRight}>
                  共{this.state.totalLen}条诊断 已选中
                  <i>{this.state.selectedDataArray.diagIds.length}</i>条
                </span>
              </div>
              <div className="ai-report-list">
                <Collapse
                  defaultActiveKey={this.state.defaultActiveKey}
                  activeKey={this.state.defaultActiveKey}
                  expandIcon={({ isActive }) => (
                    <Icon type="caret-right" rotate={isActive ? 90 : 0} />
                  )}
                  onChange={this.collapseCallback}
                >
                  {this.getReportContent()}
                </Collapse>
              </div>
            </div>
            {from === 'report' && dicomId ? (
              <div className="ai-report-result">
                <p className="title">影像所见</p>
                <div
                  className="content"
                  dangerouslySetInnerHTML={{ __html: findingContent }}
                ></div>
                <p className="title">诊断建议</p>
                <div
                  className="content"
                  dangerouslySetInnerHTML={{ __html: diagContent }}
                ></div>
              </div>
            ) : (
              <div className="ai-report-button-content">
                <Button
                  className="ai-report-button"
                  type="primary"
                  onClick={this.updateAdopted}
                  disabled={this.state.selectedDataArray.diagIds.length === 0}
                >
                  <ArrowRightIcon />
                  合成并插入报告输入框内
                </Button>
              </div>
            )}
          </TabPane>
          {from === 'report' && dicomId ? (
            <TabPane tab="医生审核" key="2">
              <div className="review-group">
                <div className="title">
                  {i18n.t('seniorRadiologistReview')}
                  <Button
                    type="link"
                    className={
                      ('report-status', reviewStatus >= '2' ? 'success' : '')
                    }
                  >
                    {reviewStatus === '0' && <>{shalouIcon} 待审核</>}
                    {reviewStatus === '1' && <>... 审核中</>}
                    {reviewStatus === '2' && (
                      <>
                        <Icon type="check" /> 已审核
                      </>
                    )}
                    {reviewStatus === '3' && (
                      <>
                        <Icon type="check" /> 已打印
                      </>
                    )}
                    {reviewStatus === '-2' && <>无需审核</>}
                  </Button>
                </div>
                <div className="content">
                  <div className="suggest-box">
                    <div>
                      {doctorReviewList.map((item, index) => {
                        return (
                          <div className="item" key={index}>
                            <Cascader
                              fieldNames={{
                                label: 'diseaseName',
                                value: 'id',
                                children: 'childs',
                              }}
                              options={doctorConfigs}
                              placeholder="请选择诊断建议"
                              value={item.value}
                              defaultValue={item.value}
                              allowClear={false}
                              disabled={true}
                              style={{ width: '335px' }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="content report-text">
                  <TextArea
                    rows={6}
                    disabled={true}
                    value={textAreaValue}
                    style={{ width: '335px' }}
                  />
                </div>
                <div className="reviewed-by" style={{ width: '335px' }}>
                  {reviewDoctorName && (
                    <span>
                      <span style={{ color: '#9EBBC3' }}>
                        {i18n.t('reviewedByDr')}&nbsp;
                      </span>
                      {reviewDoctorName}
                    </span>
                  )}
                </div>
              </div>
            </TabPane>
          ) : null}
        </Tabs>
      </div>
    );
  }
}

export default withRouter(Form.create()(AiReport));
